import * as React from 'react';
import { Suspense } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import routes, { renderRoutes } from './routes';
import { AuthProvider } from './authentication/authContext';
import GoogleAnalytics from '../src/components/GoogleAnalytics';
import Loader from '../src/components/Loader';
import theme from './theme';
import { isLocalHost } from './utils/hosting';

function App() {
	return (
		<ThemeProvider theme={theme}>
			<Suspense fallback={<Loader />}>
				<AuthProvider>
					<GoogleAnalytics enabled={!isLocalHost} />
					{renderRoutes(routes)}
				</AuthProvider>
			</Suspense>
		</ThemeProvider>
	);
}

export default App;
